export const API_URLS = {
  resellerProfile: "reseller_app/reseller-profile-details/",
  resellerState: "state-list-data/",
  resellerCity: "city-list-data/",
  resellerStoreList: "reseller_app/reseller-store-data-list/",
  specificationTypes: "api/admin/product-specification-type-api/",
  specifications: "api/admin/product-specification-api/",
  category: "api/admin/category-admin-api/",
  subCategory: "api/admin/subcategory-admin-api/",
  brandList: "api/admin/brand-admin-api/",
  productApi: "api/admin/product-admin-api/",
  productVariantApi: "api/admin/product-variant-admin-api/",
  colorVariantApi: "api/admin/type-one-variant-value-api/",
  colorTypeApi: "api/admin/type-one-variant-api/",
  storageVariantApi: "api/admin/type-two-variant-value-api/",
  storageTypeApi: "api/admin/type-two-variant-api/",
  otherVariantApi: "api/admin/type-three-variant-value-api/",
  otherTypeApi: "api/admin/type-three-variant-api/",
  uploadVariantByExcelApi:
    "api/admin/upload-product-variant-by-excel-admin-api/",
  multipleImageApi: "api/admin/product-variant-multiple-image-admin-api/",
  product_specification: "product-variant-specification-admin-api",
  variantListCopy: "api/admin/copy-product-variant-specification-admin-api/",
  variantCombo: "api/admin/create-possible-product-variant-combination-admin/",
  variantSelectImage: "api/admin/copy-product-variant-image-admin-api/",
  codManagement: "api/admin/set-cod-amount-api/"
};
